import {setFilters, getFiltersNgoLength} from "./index";

export function initMultiselect(ngos = [], apiUrl) {
    const panel = document.getElementById('ms-panel');
    const toggle = document.getElementById('ms-toggle');
    const options = document.getElementById('ms-options');
    const multiselect = document.getElementById('multiselect-1');
    const close = document.getElementById('ms-close');
    const countSpan = document.querySelector('#filterCount');
    const badgeContainer = document.getElementById('ms-mobile-badges')

    function updateBadges() {
        badgeContainer.innerHTML = '';

        const checkedCheckboxes = options.querySelectorAll('input:checked');

        checkedCheckboxes.forEach(checkbox => {
            const value = checkbox.value;
            const labelText = checkbox.parentElement.textContent.trim();

            const badge = document.createElement('div');
            badge.className = 'ms-mobile-badge';
            badge.id = `badge-${value}`;
            badge.innerHTML = `${labelText}<span class="ms-mobile-badge--close"></span>`;

            const closeBtn = badge.querySelector('.ms-mobile-badge--close');
            closeBtn.addEventListener('click', (e) => {
                e.stopPropagation(); // Prevent event bubbling

                const checkboxToUncheck = options.querySelector(`input[value="${value}"]`);
                if (checkboxToUncheck) {
                    checkboxToUncheck.checked = false;

                    const event = new Event('change');
                    checkboxToUncheck.dispatchEvent(event);
                }

                badge.remove();

                const hasChecked = options.querySelector('input:checked');
                panel.classList.toggle('checked', !!hasChecked);
            });

            badgeContainer.appendChild(badge);
        });

        const hasChecked = checkedCheckboxes.length > 0;
        panel.classList.toggle('checked', hasChecked);

        if(getFiltersNgoLength() !== null){
            panel.classList.add('active')
            countSpan.innerHTML = `(${getFiltersNgoLength()})`
        }else{
            panel.classList.remove('active')
            countSpan.innerHTML = ``
        }
    }

    function handleCheckboxChange(event) {
        const checkbox = event.target;
        const value = checkbox.value;
        const labelText = checkbox.parentElement.textContent.trim();

        if (checkbox.checked) {
            const badge = document.createElement('div');
            badge.className = 'ms-mobile-badge';
            badge.id = `badge-${value}`;
            badge.innerHTML = `${labelText}<span class="ms-mobile-badge--close"></span>`;

            const closeBtn = badge.querySelector('.ms-mobile-badge--close');
            closeBtn.addEventListener('click', (e) => {
                e.stopPropagation();

                checkbox.checked = false;

                badge.remove();

                const hasChecked = options.querySelector('input:checked');
                panel.classList.toggle('checked', !!hasChecked);
            });

            badgeContainer.appendChild(badge);
        } else {
            const badge = document.getElementById(`badge-${value}`);
            if (badge) {
                badge.remove();
            }
        }

        const hasChecked = options.querySelector('input:checked');
        panel.classList.toggle('checked', !!hasChecked);
    }

    if (ngos.length) {
        ngos.sort((a, b) => a.id.localeCompare(b.id));

        options.innerHTML = '';
        ngos.forEach(ngo => {
            const label = document.createElement('label');
            label.classList.add('ms-item');

            const input = document.createElement('input');
            input.type = 'checkbox';
            input.value = ngo.id;

            input.addEventListener('change', handleCheckboxChange);

            label.appendChild(input);

            const textNode = document.createTextNode(' ' + ngo.name);
            label.appendChild(textNode);

            options.appendChild(label);
        });
    }

    toggle.addEventListener('click', () => {
        const show = !panel.classList.contains('show');
        panel.classList.toggle('show', show);
        toggle.setAttribute('aria-expanded', show ? 'true' : 'false');

        if (show) {
            updateBadges();
        }
    });

    document.addEventListener('click', (e) => {
        if (!multiselect.contains(e.target)) {
            panel.classList.remove('show');
            toggle.setAttribute('aria-expanded', 'false');
        }
    });

    toggle.addEventListener('keydown', (ev) => {
        if (ev.key === 'Enter' || ev.key === ' ') {
            ev.preventDefault();
            toggle.click();
        }
    });

    close.addEventListener('click', () => {
        panel.classList.toggle('show');
        toggle.setAttribute('aria-expanded', 'false');
    });

    const filterBtn = panel.querySelector('.ms-filter');
    filterBtn.addEventListener('click', async () => {
        const selectedIds = Array.from(options.querySelectorAll('input:checked'))
            .map(input => input.value);
        if (selectedIds.length === 0) {
            setFilters({ ngo: null }, apiUrl);
            updateBadges();
            return;
        }

        setFilters({ ngo: selectedIds.join(',') }, apiUrl);
        panel.classList.remove('show');
        toggle.setAttribute('aria-expanded', 'false');

        updateBadges();
    });

    const clearBtn = panel.querySelector('.ms-clear');
    clearBtn.addEventListener('click', () => {
        const checkboxes = options.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
        setFilters({ ngo: null }, apiUrl);
        panel.classList.remove('show');
        panel.classList.remove('checked');
        toggle.setAttribute('aria-expanded', 'false');

        updateBadges();
    });

    updateBadges();
}